import React, { useEffect } from "react";
import "../../../style/landing.css";

import img1 from "../../../image/privacy-pop-right-img.webp";
import img2 from "../../../image/privacy-pop-img-left.webp";

import Navbar from "../navbar/Navbar";

const Term = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <header className="lp-hero-container hero-section">
        <div className="lp-container">
          <Navbar />

          <h1 className="lp-heading">
            Terms & <span style={{ color: "#00BFA6" }}>Conditions </span>
          </h1>

          <div className="lp-wailist-section">
            <img src={img2} alt="Newslettrai" className="side-img" />

            <p className="lp-heading-desc">
              Your trust matters. Our terms ensure clarity and fairness, guiding{" "}
              <br />
              how you use our services effectively.
            </p>

            <img
              src={img1}
              alt="Newslettrai"
              style={{ marginTop: "-80px" }}
              className="side-img"
            />
          </div>
        </div>
      </header>

      <main className="lp-container">
        <article className="privacy-policy">
          <p className="effective-date">Effective Date: 20-01-2025</p>
          <p>
            These terms and conditions outline the rules and regulations for the
            use of NewslettrAI's Email Marketing Platform, located at
            https://www.newslettrai.com.
          </p>
          <br />
          <p>
            By accessing this platform, we assume you accept these terms and
            conditions. Do not continue to use NewslettrAI if you do not agree
            to take all of the terms and conditions stated on this page.
          </p>
          <br />
          <p>
            The following terminology applies to these Terms and Conditions,
            Privacy Statement, and Disclaimer Notice and all Agreements:
            "Client," "You," and "Your" refer to you, the person logging into
            this platform and compliant with the Company's terms and conditions.
            "The Company," "Ourselves," "We," "Our," and "Us," refer to our
            Company. "Party," "Parties," or "Us," refer to both the Client and
            ourselves. All terms refer to the offer, acceptance, and
            consideration of payment necessary to undertake the process of our
            assistance to the Client in the most appropriate manner for the
            express purpose of meeting the Client's needs in respect of the
            provision of the Company's stated services, in accordance with and
            subject to, the prevailing law of India. Any use of the above
            terminology or other words in the singular, plural, capitalization,
            and/or he/she or they, are taken as interchangeable and therefore as
            referring to the same.
          </p>
          <h2 id="cookies">Cookies</h2>
          <ul>
            <li>
              We employ the use of cookies. By accessing NewslettrAI, you agree
              to use cookies in agreement with NewslettrAI's Privacy Policy.
            </li>
            <li>
              Cookies are used to enhance your experience by storing preferences
              and tracking user interactions. Some of our third-party service
              providers may also use cookies for analytics and targeted
              advertisements.
            </li>
          </ul>
          <h2 id="license">License</h2>
          <p>
            Unless otherwise stated, NewslettrAI and/or its licensors own the
            intellectual property rights for all material on NewslettrAI. All
            intellectual property rights are reserved. You may access this from
            NewslettrAI for your personal use, subject to restrictions set in
            these terms and conditions.
          </p>
          <br></br>
          <p>You must not:</p>
          <ul>
            <li>Republish material from NewslettrAI</li>
            <li>Sell, rent, or sub-license material from NewslettrAI</li>
            <li>Reproduce, duplicate, or copy material from NewslettrAI</li>
            <li>Redistribute content from NewslettrAI</li>
          </ul>
          <p>This Agreement shall begin on the date hereof.</p>
          <h2 id="user-content">User-Generated Content</h2>
          <p>
            Certain areas of this platform allow users to post and exchange
            content, such as email templates, campaign materials, and comments.
            Newsletter does not filter, edit, publish, or review such content
            before it appears on the platform . The views and opinions expressed
            belong solely to the users and do not reflect the views of the
            Newsletter.
          </p>
          <br />
          <p>
            Newsletter reserves the right to monitor and remove any content
            deemed inappropriate, offensive, or in violation of these terms.
          </p>
          <br />
          You warrant and represent that:
          <ul>
            <li>
              You have the right to post content and hold the necessary licenses
              or consents.
            </li>
            <li>
              Your content does not violate any third-party intellectual
              property rights.
            </li>
            <li>
              Your content does not contain defamatory, obscene, or unlawful
              material.
            </li>
            <li>
              Your content will not be used for unauthorized promotional
              purposes.
            </li>
          </ul>
          <p>
            By posting content, you grant Newsletter a non-exclusive license to
            use, reproduce, and distribute it in any form or media.
          </p>
          <h2 id="hyperlinking">Hyperlinking to Our Content</h2>
          <p>
            The following organizations may link to our platform without prior
            approval:
          </p>
          <br />
          <ul>
            <li>Government agencies</li>
            <li>Search engines</li>
            <li>News organizations</li>
            <li>Online directories linking to business sites similarly</li>
          </ul>
          <p>
            Other organizations may request approval for linking, which will be
            reviewed based on relevance, reputation, and compliance with our
            linking policies.
          </p>
          <br />
          <p>
            Approved organizations may link to our platform using our corporate
            name, URL, or other appropriate descriptions, ensuring the link does
            not misrepresent our platform in any way.
          </p>
          <h2 id="email-marketing">Email Marketing and Account Usage</h2>
          <p>By using our email marketing services, you agree to:</p>
          <br />
          <ul>
            <li>
              Send emails only to recipients who have provided consent,
              complying with anti-spam regulations such as the CAN-SPAM Act and
              GDPR.
            </li>
            <li>
              Use accurate sender information and avoid misleading content.
            </li>
            <li>
              Maintain compliance with applicable laws and regulations governing
              email communications.
            </li>
          </ul>
          <p>
            Failure to comply with these rules may result in account suspension
            or termination.
          </p>
          <h2 id="iframes">iFrames</h2>
          <p>
            Without prior approval and written permission, you may not create
            frames around our web pages that alter the visual presentation or
            appearance of our platform.
          </p>
          <h2 id="content-liability">Content Liability</h2>
          <p>
            We are not responsible for any content that appears on your email
            campaigns. You agree to indemnify and defend us against claims
            arising from the content you send via our platform. No campaign
            should contain material that may be considered defamatory, obscene,
            or unlawful.
          </p>
          <h2 id="disclaimer">Disclaimer</h2>
          <p>
            To the maximum extent permitted by law, we exclude all warranties,
            representations, and conditions relating to our platform and the use
            of this platform. Nothing in this disclaimer will:
          </p>
          <ul>
            <li>
              Limit or exclude our or your liability for death or personal
              injury.
            </li>

            <li>
              Limit any of our or your liabilities in ways not permitted under
              applicable law.
            </li>

            <li>
              Exclude any liabilities that may not be excluded under applicable
              law.
            </li>
          </ul>
          <p>
            As long as the platform and services are provided free of charge, we
            will not be liable for any loss or damage of any nature.
          </p>
          <h2 id="privacy-policy">Privacy Policy</h2>
          <p>
            Your use of our platform is also governed by our Privacy Policy,
            which explains how we collect, store, and protect your personal
            data.
          </p>
        </article>
      </main>
    </>
  );
};

export default Term;
